<template>
  <div id="app">
    <transition :name="transitionName">
      <!-- ArticleDetail 先不缓存详情页面 router replace会报错 -->
      <keep-alive include="tagList,List,ArticleDetail,AuthorArticle">
        <router-view :key="$route.fullPath" />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      transitionName: '',
    };
  },
  watch: {
    $route(to, from) {
      if (this.env.inWechatMiniProgram) return;
      const { stamp: toStamp } = to.query;
      const { stamp: fromStamp = 0 } = from.query;
      const toStampNum = Number(toStamp);
      const fromStampNum = Number(fromStamp);

      if (toStampNum === fromStampNum || fromStampNum === 0) {
        this.transitionName = '';
        return;
      }
      this.transitionName =
        toStampNum > fromStampNum ? 'swipe-left' : 'swipe-right';
    },
  },
};
</script>
<style lang="less">
@import './assets/styles/index';
#app {
  background: #f5f5f5;
}
</style>
